exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login[data-v-5e2efa4f] {\n  height: 0%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  content: \"\";\n  z-index: 0;\n}\n#divider[data-v-5e2efa4f] {\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  content: \"\";\n  z-index: 0;\n  background-size: cover;\n  overflow: hidden;\n}", ""]);

// exports
